import * as React from "react";
import {cx} from "emotion";

import "./controls.scss";

import {OnGlobalKeyDownEscape} from "@Common/ui-components/browser/global-key-down-escape";

export const Controls = ({className, controls, spread}) => (
    <div className={cx("controls controls-58f", className, {spread})}>

        {controls.mode.current && (
            OnGlobalKeyDownEscape({
                action: controls.mode.clear,
            })
        )}

        {Button({
            icon: "crop",
            label: "Crop",
            selected: controls.crop.selected,
            onClick: controls.crop.toggle,
            dropdown: true,
        })}
        {Button({
            icon: "rotate-right",
            label: "Rotate",
            onClick: controls.rotate,
        })}
        {Button({
            icon: "arrows-h",
            label: "Flip",
            onClick: controls.flip,
        })}

        {Button({
            icon: "sliders",
            label: "Color",
            active: controls.filter.active,
            selected: controls.filter.selected,
            dropdown: true,
            onClick: controls.filter.toggleMode,
        })}
        {Button({
            icon: "user-circle",
            label: "Mask",
            dropdown: true,
            active: controls.mask.active,
            selected: controls.mask.selected,
            onClick: controls.mask.toggleMode,
            // selected: true,
        })}

        {/*{Button({*/}
        {/*    icon: "info-circle",*/}
        {/*    label: "Info",*/}
        {/*})}*/}

        {/*{Buttons({controls})}*/}
    </div>
);

const Button = ({icon, label, active=false, onClick=undefined, dropdown=false, selected=false}) => (
    <div className={cx("button", {selected})} onClick={onClick} xd-qa-type="icon" xd-qa-name={label}>
        <div className={cx("box", )}>
            <div className="active-indicator">
                {active && (
                    <div className="dot"/>
                )}
            </div>
            <i className={"fa fa-" + icon}/>
            <div className="label">
                {label}
            </div>

            {dropdown && (
                <div className="dropdown-indicator">
                    <i className="fa fa-caret-down"/>
                </div>
            )}
        </div>
    </div>
);

